/**
 * File: commonFilterController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

class CommonFilterController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdDialog, $filter, $stateParams, localStorageService, authService, filterCons, CONSTANTS) {

        let multipleBatchFilterCtrl = this;
        var vm = this;
        vm.limit = 50;
        vm.Items = 60;
        vm.pager = {};
        vm.setPage = setPage;
        vm.pageIndex = [];

        function GetPager(totalItems, currentPage, pageSize) {
            // default to first page
            currentPage = currentPage || 1;
            pageSize = pageSize || vm.limit;
            var totalPages = Math.ceil(totalItems / pageSize);
            var startPage, endPage;
            if (totalPages <= 10) {
                startPage = 1;
                endPage = totalPages;
            } else {
                if (currentPage <= 6) {
                    startPage = 1;
                    endPage = 10;
                } else if (currentPage + 4 >= totalPages) {
                    startPage = totalPages - 9;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - 5;
                    endPage = currentPage + 4;
                }
            }

            var startIndex = (currentPage - 1) * pageSize;
            var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
            var pages = _.range(startPage, endPage + 1);
            return {
                totalItems: totalItems,
                currentPage: currentPage,
                pageSize: pageSize,
                totalPages: totalPages,
                startPage: startPage,
                endPage: endPage,
                startIndex: startIndex,
                endIndex: endIndex,
                pages: pages
            };
        }

        function initController() {
            $scope.announcementForAll = multipleBatchFilterCtrl.checkAnnouncementReceivers
            if (multipleBatchFilterCtrl.checkAnnouncementReceivers) {
                console.log('SEND TO ALL')
                multipleBatchFilterCtrl.getAllUsersForAnnouncement()
                $scope.showFilteredUsers = false;
            } else {
                vm.setPage(1);
            }
        }

        function setPage(page) {
            if (page < 1 || page > vm.pager.totalPages) {
                return;
            }
            vm.pager = GetPager(vm.Items, page);
            console.log(vm.pager)
            $scope.showFilteredUsers = true;
            if (vm.pageIndex.indexOf(page) === -1) {

                if (page === 1)
                    multipleBatchFilterCtrl.getUsersLists(0, vm.limit, page);
                else
                    multipleBatchFilterCtrl.getUsersLists(vm.pager.startIndex, vm.limit, page);
            } else {
                findValueBasedOnIndex(page)
            }
        }

        $scope.filteredEndorsedUsers = []
        $scope.selectedFilterData = "Select.."
        $scope.userNamesNotEndorsed = []
        $scope.showAcademicFilters = true;
        $scope.isBatch = false;
        $scope.isClass = false;
        multipleBatchFilterCtrl.checkAllClass = false;
        $scope.showSavedSearch = false;
        $scope.saveSearchData = false;
        $scope.showbatch = true;
        $scope.isSearched = false;
        $scope.showMultiBatch = [];
        multipleBatchFilterCtrl.showChart = [];
        $scope.filterObj = {}
        $scope.buttonName = 'Add'
        $scope.open = false;
        $scope.announcementForAll = false;

        var everywhere = angular.element(window.document);
        everywhere.bind('click', function(event) {

            try {
                var isButtonClick = event.target.className === "btn-filter btn-primary dropdown-toggle ng-binding";
                if (isButtonClick === false) {
                    $scope.open = false;
                    _.defer(function() {
                        $scope.$apply();
                    });;
                }
            } catch (ex) {

            }
        })

        function findValueBasedOnIndex(page) {

            $scope.userNamesNotEndorsed = _.filter($scope.filteredNotEndorsedUsers, function(user) {
                return user.page === page
            })
            multipleBatchFilterCtrl.userNotEndorsedAcademic = _.uniq(_.pluck($scope.userNamesNotEndorsed, 'academic_details'));

        }

        function clearUsersListResults() {
            multipleBatchFilterCtrl.userNotEndorsedAcademic = [];
            $scope.userNamesNotEndorsed = [];
            $scope.filteredNotEndorsedUsers = [];
            vm.pager = {};
            vm.setPage = setPage;
            vm.pageIndex = [];
            multipleBatchFilterCtrl.allItemsSelected = [];
        }

        function clearFields() {
            multipleBatchFilterCtrl.showMultiSubject = [];
            $scope.filterObj['batch'] = [];
            $scope.filterObj['subject'] = [];
            $scope.isSubject = false;
            multipleBatchFilterCtrl.checkAll = false;
            multipleBatchFilterCtrl.checkAllSubject = false;
            vm.pager = {};
            vm.setPage = setPage;
            clearUsersListResults();
            vm.pageIndex = [];
            multipleBatchFilterCtrl.allItemsSelected = [];
        }


        clearFields();

        $scope.chartTypes = [{
                name: 'Pie',
                type: 'pie'
            }, {
                name: 'Bar',
                type: 'Bar'
            }, {
                name: 'Doughnut',
                type: 'Doughnut'
            }

        ];


        function featureBaseFilter() {
            switch ($scope.stateId) {
                case 'userManagement':
                    hideUserManagementFilterFields();
                    break;
                case 'reportGradeDetailsConsole':
                    hideReportGradeDetailsConsoleFields();
                    break;
                case 'announcementsUsers':
                    $scope.buttonName = 'Proceed'
                    $scope.announcementForAll = true
                    hideClubFilterFields();
                    break;
                case 'club':
                    $scope.buttonName = 'Add'
                    hideClubFilterFields();
                    break;
                case 'manageReportCards':
                    $scope.buttonName = 'Add'
                    hidefilterInManageReports()
                    break;
                case 'viewDetails':
                    $scope.buttonName = 'Proceed'
                    forSecurityAppConsole();
                    break;
                case 'transferStudent':
                    $scope.buttonName = 'Search'
                    roleasStudentOnly();
                    break;
                case 'edituser':
                    $scope.buttonName = 'Search'
                    forEditinguser();
                    break;
                case 'removeUser':
                    forRemoveUser();
                    break;

            }
        }

        featureBaseFilter();

        function forRemoveUser() {
            $scope.visibleRole = true;
            $scope.showAcademicFilters = true;
            $scope.showbatch = true;
            $scope.showSubject = false;
            $scope.showChart = false;
            $scope.showMultiRole = false;
            $scope.showDate = false;
            $scope.blnsearchValuesBasedOnFilter = true;
            $scope.blnsearchValuesBasedOnFilterOnComponent = false;
            $scope.showSavedSearchField = true;
            $scope.showFilteredUsers = false;

        }

        function forEditinguser() {
            $scope.visibleRole = true;
            $scope.showAcademicFilters = true;
            $scope.showbatch = true;
            $scope.showSubject = false;
            $scope.showChart = false;
            $scope.showMultiRole = false;
            $scope.showDate = false;
            $scope.blnsearchValuesBasedOnFilter = true;
            $scope.blnsearchValuesBasedOnFilterOnComponent = false;
            $scope.showSavedSearchField = false;
            $scope.showFilteredUsers = false;
        }

        function hidefilterInManageReports() {
            $scope.visibleRole = false;
            $scope.showAcademicFilters = true;
            $scope.showbatch = false;
            $scope.showSubject = false;
            $scope.showChart = false;
            $scope.showMultiRole = false;
            $scope.showDate = false;
            $scope.blnsearchValuesBasedOnFilter = true;
            $scope.blnsearchValuesBasedOnFilterOnComponent = false;
            $scope.showSavedSearchField = false;
            $scope.showFilteredUsers = false;
        }

        function hideClubFilterFields() {
            $scope.visibleRole = true;
            $scope.showAcademicFilters = true;
            $scope.showbatch = true;
            $scope.showSubject = false;
            $scope.showChart = false;
            $scope.showMultiRole = false;
            $scope.showDate = false;
            $scope.blnsearchValuesBasedOnFilter = false;
            $scope.blnsearchValuesBasedOnFilterOnComponent = true;
            $scope.showSavedSearchField = true;
            $scope.showFilteredUsers = false;
        }

        function hideUserManagementFilterFields() {
            $scope.visibleRole = true;
            $scope.showAcademicFilters = true;
            $scope.showbatch = true;
            $scope.showSubject = false;
            $scope.showChart = false;
            $scope.showMultiRole = false;
            $scope.showDate = false;
            $scope.blnsearchValuesBasedOnFilter = true;
            $scope.blnsearchValuesBasedOnFilterOnComponent = false;
            $scope.showSavedSearchField = true;
            $scope.showFilteredUsers = true;

        }

        function roleasStudentOnly() {
            $scope.visibleRole = false;
            $scope.showAcademicFilters = true;
            $scope.showbatch = true;
            $scope.showSubject = false;
            $scope.showChart = false;
            $scope.showMultiRole = false;
            $scope.showDate = false;
            $scope.blnsearchValuesBasedOnFilter = true;
            $scope.blnsearchValuesBasedOnFilterOnComponent = false;
            $scope.showSavedSearchField = true;
            $scope.showFilteredUsers = false;

            $scope.filterObj['role'] = 'student'
            $scope.filterObj['role_id'] = 'student'
        }

        function forSecurityAppConsole() {
            $scope.visibleRole = false;
            $scope.showAcademicFilters = true;
            $scope.showbatch = true;
            $scope.showSubject = false;
            $scope.showChart = false;
            $scope.showMultiRole = false;
            $scope.showDate = false;
            $scope.blnsearchValuesBasedOnFilter = false;
            $scope.blnsearchValuesBasedOnFilterOnComponent = true;
            $scope.showSavedSearchField = true;
            $scope.showFilteredUsers = true;

            $scope.filterObj['role'] = 'student'
            $scope.filterObj['role_id'] = 'student'
        }

        let subsModules = undefined,
            subsAcademicSet = undefined,
            subsAcademicPack = undefined,
            academicDetail = undefined

        /*
         * To get user's assigned module's features
         * 
         * @Developer : Jeevanantham N
         */
        let getUserModules = () => {
            authService.callAPI(filterCons.API_GET_MODULE_FEATURE + localStorageService.get('school_id') + "/" + "roleSetting", "GET", {}, (response) => {
                if (response.result && response.result.data && response.result.data.module_features) {
                    try {
                        moduleDetails = response.result.data.module_features
                        let parentId = ''
                        let principalId = ''
                        let vicePrincipalId = ''
                        let senEducatorId = ''
                        let senCoordinatorId = ''
                        let senCounselorId = ''
                        if (moduleDetails != undefined && moduleDetails.feature_role && $scope.isClub) {
                            _.each(moduleDetails.feature_role, function(each) {
                                if (each.f_id == 'parentComponent' && each.privilege[0].status) {
                                    parentId = each.role_id
                                } else if (each.f_id == 'principalComponent' && each.privilege[0].status) {
                                    principalId = each.role_id
                                } else if (each.f_id == 'vicePrincipalComponent' && each.privilege[0].status) {
                                    vicePrincipalId = each.role_id
                                } else if (each.f_id == 'senEducatorComponent' && each.privilege[0].status) {
                                    senEducatorId = each.role_id
                                } else if (each.f_id == 'senCoordinatorComponent' && each.privilege[0].status) {
                                    senCoordinatorId = each.role_id
                                } else if (each.f_id == 'senCounselorComponent' && each.privilege[0].status) {
                                    senCounselorId = each.role_id
                                }
                            })
                        }
                        _.defer(function() {
                            $scope.$apply();
                        });
                    } catch (ex) {
                        console.log(ex)
                    }
                }
            })
        }


        /*
         * To get school based academic deatils
         * 
         * @Developer : Jeevanantham N
         */
        let getAcademicPck = () => {
            authService.callAPI(filterCons.API_GET_SCHOOL_ACADEMICS + localStorageService.get('school_id'), "GET", {}, (response) => {
                console.log(response)
                if (response.result && response.result.data && response.result.data.academic_det) {
                    //$scope.hodPersonArr = response.result.data.departments

                    $scope.sessions = []
                    academicDetail = response.result.data.academic_det

                    if (academicDetail === undefined || academicDetail.length <= 0)
                        return false;


                    if (multipleBatchFilterCtrl.allSessions && academicDetail) {
                        _.each(academicDetail, function(doc) {
                            let thisSessionDetails = _.find(multipleBatchFilterCtrl.allSessions.list, function(eachSession) {
                                return eachSession._id == doc.session_id
                            })
                            if (thisSessionDetails && !_.find($scope.sessions, function(sess) {
                                    return sess._id == thisSessionDetails._id
                                })) {
                                $scope.sessions.push({
                                    _id: thisSessionDetails._id,
                                    name: thisSessionDetails.name
                                })
                            }
                        })
                    }


                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }


        /*
         * To get school based settings
         * 
         * @Developer : Jeevanantham N
         */
        let getAcademicSettings = () => {
            authService.callAPI(filterCons.API_GET_SCHOOL_SETTINGS + localStorageService.get('school_id'), "GET", {}, (response) => {
                console.log(response)
                if (response.result && response.result.data) {
                    multipleBatchFilterCtrl.rolePackage = response.result.data.role_det ? response.result.data.role_det : []

                    multipleBatchFilterCtrl.allSessions = response.result.data.session_det ? response.result.data.session_det : []

                    multipleBatchFilterCtrl.allCurriculum = response.result.data.curriculum_det ? response.result.data.curriculum_det : []

                    multipleBatchFilterCtrl.allClassess = response.result.data.class_det ? response.result.data.class_det : []

                    multipleBatchFilterCtrl.allBatchess = response.result.data.batch_det ? response.result.data.batch_det : []

                    multipleBatchFilterCtrl.allSubjectsList = response.result.data.subject_det ? response.result.data.subject_det : []

                    if (multipleBatchFilterCtrl.allSessions && academicDetail) {
                        _.each(academicDetail, function(doc) {
                            let thisSessionDetails = _.find(multipleBatchFilterCtrl.allSessions.list, function(eachSession) {
                                return eachSession._id == doc.session_id
                            })
                            if (thisSessionDetails && !_.find($scope.sessions, function(sess) {
                                    return sess._id == thisSessionDetails._id
                                })) {
                                $scope.sessions.push({
                                    _id: thisSessionDetails._id,
                                    name: thisSessionDetails.name
                                })
                            }
                        })
                    }

                    $scope.allRoles = [];

                    if ($scope.isClub) {
                        if (multipleBatchFilterCtrl.rolePackage) {
                            _.each(multipleBatchFilterCtrl.rolePackage.list, function(role) {
                                if ((role._id != CONSTANTS.ADMIN_ID && role._id != parentId && role._id != senEducatorId && role._id != senCoordinatorId && role._id != principalId && role._id != vicePrincipalId && role._id != senCounselorId && role.status === true)) {
                                    $scope.allRoles.push(role)
                                }
                            })
                        }
                    } else if (multipleBatchFilterCtrl.rolePackage) {
                        $scope.allRoles = _.filter(multipleBatchFilterCtrl.rolePackage.list, function(role) {
                            return role._id != CONSTANTS.ADMIN_ID && role.status === true
                        })
                    } else {
                        return false;
                    }

                    getSubJectPack()

                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /*
         * To get saved search details
         * 
         * @Developer : Jeevanantham N
         */
        let getSavedSearch = () => {
            authService.callAPI(filterCons.API_GET_SAVED_SEARCH + localStorageService.get('school_id') + "/" + $scope.stateId, "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.search_det) {
                    //$scope.hodPersonArr = response.result.data.departments

                    $scope.savedSearchData = response.result.data.search_det

                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /*
         * To get user's academic details
         * 
         * @Developer : Jeevanantham N
         */
        let userPrsnData = (user_id) => {
            authService.callAPI(filterCons.API_GET_PERSON_ACDEMICS + localStorageService.get('school_id') + "/" + localStorageService.get("user_id"), "GET", {}, (response) => {

                if (response.result && response.result.data && response.result.data.person_data) {
                    $scope.persnData = response.result.data.person_data

                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }


        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
                /*  if ($rootScope.isLoggedIn) {
                     $state.go("login", {}, {
                         reload: true
                     })
                 } */
            getUserModules()
            getAcademicSettings()
            getAcademicPck()
            getSavedSearch()
            userPrsnData()
        }

        this.$onDestroy = () => {

        }


        function getSubJectPack() {
            multipleBatchFilterCtrl.allSubjects = _.flatten(_.pluck(multipleBatchFilterCtrl.allSubjectsList, 'list'))
        }

        multipleBatchFilterCtrl.getRoleDetails = (id) => {
            if (multipleBatchFilterCtrl.selectedSavedSerach != undefined) {
                if (multipleBatchFilterCtrl.selectedSavedSerach.role != id) {
                    $scope.selectedFilterData = "Select.. "
                };

            };

            try {
                $scope.multiRoles = _.filter(multipleBatchFilterCtrl.rolePackage.list, function(role) {
                    return role._id != SuperAdminTYPE && role._id != AdminTYPE && role._id != id && role.status === true
                })

            } catch (ex) {


            }
        }

        function clearFilterResult() {
            if ($scope.stateId) {

                $scope.clearParentFields();
            }
        }

        $scope.setFilterObj = function(data, key) {
            console.log(data)
            console.log(key)
            console.log($scope.filterObj)
            $scope.open = false;
            clearFilterResult()
            if (key == 'Role') {
                $scope.filterObj['role'] = data
                clearComponentField()
            } else if (key == 'Session') {
                $scope.filterObj['session'] = data
            } else if (key == 'Curiculum') {
                $scope.filterObj['curriculum'] = data
            } else if (key == 'role_id') {
                clearComponentField()
                $scope.filterObj['role_id'] = data
            } else if (key == 'Chart') {
                $scope.filterObj['chart'] = data
            } else if (key == 'Multi') {
                $scope.filterObj['multirole'] = data
            }
        }

        function clearComponentField() {
            $scope.filteredEndorsedUsers = [];
            multipleBatchFilterCtrl.userEndorsedAcademic = [];
            multipleBatchFilterCtrl.userNotEndorsedAcademic = [];
            $scope.userNamesNotEndorsed = [];
            $scope.filteredNotEndorsedUsers = [];
            vm.pager = {};
            vm.setPage = setPage;
            vm.pageIndex = [];
            multipleBatchFilterCtrl.allItemsSelected = [];
        }

        $scope.removeFilter = function() {
            $scope.filterObj = {}
            $scope.filteredExamDetails = []
        }

        $scope.setSessionFilters = (item) => {
            let items = item.split(",")
        }

        $scope.deleteSearch = (item) => {
            $scope.open = false;

            let obj = {
                'search_id': item._id,
                'school_id': localStorageService.get('school_id')
            }

            /*
             * To removed filter data
             * 
             * @Developer : Jeevanantham N
             */
            authService.callAPI(filterCons.API_POST_REMOVE_SERACH, "POST", obj, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.info) {
                    $scope.selectedFilterData = "Select.. "
                    getSavedSearch()
                    toastr.success('Deleted Successfully')
                } else {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                }
            })

        }

        multipleBatchFilterCtrl.getBatch = function(bid) {

            //console.log("wwwwwwwwww")
            $scope.open = false;
            clearUsersListResults();
            $scope.batchId = bid
            $scope.isBatch = true
            $scope.isSubject = false
            $scope.filterObj['batch'] = []
            $scope.filterObj['subject'] = [];
            let flag = false;
            for (let i = 0; i < $scope.filterObj['xclass'].length; i++) {
                if ($scope.filterObj['xclass'][i] === bid) {
                    flag = true
                }
            }
            multipleBatchFilterCtrl.showMultiSubject = [];
            multipleBatchFilterCtrl.checkAll = false
            multipleBatchFilterCtrl.checkAllSubject = false


            multipleBatchFilterCtrl.showThisBatch = _.find(academicDetail, (lst) => {
                return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass
            })

            var classDet = _.find(multipleBatchFilterCtrl.showThisBatch.xclass, function(batch) {
                return batch._id === bid
            })

            if ($scope.isTeacher && localStorageService.get("user_id") && multipleBatchFilterCtrl.allClassess) {

                /* let personDetails = Person.findOne({
                    user_id: localStorageService.get("user_id"),
                    "status": "active"
                }) */

                let personDetails = $scope.persnData

                if (personDetails && personDetails.details) {

                    let batchData = _.where(personDetails.details, {
                        session_id: $scope.filterObj['session'],
                        curriculum_id: $scope.filterObj['curriculum'],
                        class_id: bid
                    });

                    batchData = _.uniq(_.flatten(_.pluck(batchData, "batch_id")))

                    multipleBatchFilterCtrl.showBatchName = _.filter(multipleBatchFilterCtrl.allBatches.list, function(data) {
                        return batchData.indexOf(data._id) !== -1
                    })
                }
            } else {

                if (flag) {
                    for (let j = 0; j < classDet.batches.length; j++) {
                        for (let jj = 0; jj < multipleBatchFilterCtrl.showBatchName.length; jj++) {
                            if (multipleBatchFilterCtrl.showBatchName[jj]._id === classDet.batches[j]) {
                                multipleBatchFilterCtrl.showBatchName.splice(jj, 1)
                                break;
                            }
                        }
                    }
                } else {
                    _.each(multipleBatchFilterCtrl.allBatchess.list, function(v) {
                        _.each(classDet.batches, function(k) {
                            if (v._id === k) {
                                var item = {
                                    _id: v._id,
                                    name: v.name
                                }
                                multipleBatchFilterCtrl.showBatchName.push(item)
                            }
                        })
                    })
                }
            }
            $scope.showMultiBatch = _.uniq(multipleBatchFilterCtrl.showBatchName, false, function(p) {
                return p._id;
            });
            if ($scope.showMultiBatch.length <= 0) {
                $scope.isBatch = false
            }
        }

        multipleBatchFilterCtrl.getClass = function(sid) {
            clearFilterResult()
            $scope.open = false;

            if (multipleBatchFilterCtrl.selectedSavedSerach != undefined) {
                if (multipleBatchFilterCtrl.selectedSavedSerach.curriculum != sid) {
                    $scope.selectedFilterData = "Select.. "
                };
            };
            let cid = $scope.selectCuriculum;
            $scope.selectClass = sid;
            let addedClass = [];
            $scope.showClassName = [];
            $scope.isBatch = false
            $scope.filterObj['xclass'] = []
            $scope.filterObj['singlefieldclass'] = undefined;
            clearFields();
            /* multipleBatchFilterCtrl.showThisClass = AcademicConsole.find({
                session_id: cid,
                curriculum_id: sid
            }).fetch(); */

            multipleBatchFilterCtrl.showThisClass = _.filter(academicDetail, (lst) => {
                return lst.session_id == cid && lst.curriculum_id == sid
            })

            //console.log(multipleBatchFilterCtrl.showThisClass)
            //console.log(cid)
            //console.log(sid)

            if (multipleBatchFilterCtrl.showThisClass != undefined && multipleBatchFilterCtrl.showThisClass.length > 0) {
                _.each(multipleBatchFilterCtrl.showThisClass[0].xclass, function(classes) {
                    addedClass.push(classes._id)
                })
            }
            addedClass = _.uniq(addedClass);

            //console.log(addedClass)

            if ($scope.isTeacher && localStorageService.get("user_id") && multipleBatchFilterCtrl.allClassess) {
                /* let personDetails = Person.findOne({
                    user_id: localStorageService.get("user_id"),
                    "status": "active"
                }) */

                let personDetails = $scope.persnData

                //console.log("===11111===")
                //console.log(personDetails)

                if (personDetails && personDetails.details) {
                    let classData = _.where(personDetails.details, {
                        session_id: $scope.filterObj['session'],
                        curriculum_id: sid
                    });

                    classData = _.uniq(_.flatten(_.pluck(classData, "class_id")))

                    $scope.showClassName = _.filter(multipleBatchFilterCtrl.allClassess.list, function(data) {
                            return classData.indexOf(data._id) !== -1
                        })
                        //
                }
            } else {
                //console.log("===2222===")
                //console.log(multipleBatchFilterCtrl.allClassess)
                if (multipleBatchFilterCtrl.allClassess != undefined) {
                    _.each(multipleBatchFilterCtrl.allClassess.list, function(v) {
                        _.each(addedClass, function(k) {
                            if (v._id === k) {
                                var item = {
                                    _id: v._id,
                                    name: v.name
                                }
                                $scope.showClassName.push(item)
                            }
                        })
                    })
                }

            }

            //console.log($scope.showClassName)

            if ($scope.showClassName && $scope.showClassName.length > 0) {
                $scope.isClass = true
            }

            multipleBatchFilterCtrl.classArr = _.pluck($scope.showClassName, "_id")
        }

        multipleBatchFilterCtrl.getCuriculum = function(cid) {
            $scope.open = false;
            if (multipleBatchFilterCtrl.selectedSavedSerach != undefined) {
                if (multipleBatchFilterCtrl.selectedSavedSerach.session != cid) {
                    $scope.selectedFilterData = "Select.. "
                };
            };

            $scope.selectCuriculum = cid;
            $scope.showCurriculumName = [];
            let addedCuricullumID = [];
            $scope.filterObj['curriculum'] = undefined
            $scope.filterObj['xclass'] = []
            $scope.filterObj['singlefieldclass'] = undefined;
            clearFields()
            $scope.showMultiBatch = []
            multipleBatchFilterCtrl.checkAllClass = false
            $scope.showClassName = [];
            multipleBatchFilterCtrl.showBatchName = [];
            $scope.isBatch = false
            $scope.isClass = false

            /* multipleBatchFilterCtrl.showThisSessions = AcademicConsole.find({
                session_id: cid
            }).fetch(); */

            multipleBatchFilterCtrl.showThisSessions = _.filter(academicDetail, (lst) => {
                return lst.session_id == cid
            })

            _.each(multipleBatchFilterCtrl.showThisSessions, function(v) {
                addedCuricullumID.push(v.curriculum_id)
            })
            addedCuricullumID = _.uniq(addedCuricullumID);
            $scope.showCurriculumName = [];

            if ($scope.isTeacher && localStorageService.get("user_id") && multipleBatchFilterCtrl.allCurriculum) {
                /* let personDetails = Person.findOne({
                    user_id: localStorageService.get("user_id"),
                    "status": "active"
                }) */

                let personDetails = $scope.persnData

                if (personDetails && personDetails.details) {
                    let currData = _.where(personDetails.details, {
                        session_id: cid
                    });

                    currData = _.uniq(_.flatten(_.pluck(currData, "curriculum_id")))

                    $scope.showCurriculumName = _.filter(multipleBatchFilterCtrl.allCurriculum.list, function(data) {
                        return currData.indexOf(data._id) !== -1
                    })
                }
            } else {

                _.each(multipleBatchFilterCtrl.allCurriculum.list, function(v) {
                    _.each(addedCuricullumID, function(k) {
                        if (v._id === k) {
                            var item = {
                                _id: v._id,
                                name: v.name
                            }
                            $scope.showCurriculumName.push(item)
                        }

                    })
                })
            }
        }

        multipleBatchFilterCtrl.getSubject = function() {
            $scope.open = false;
            multipleBatchFilterCtrl.checkAllSubject = false
            getAllSubject();
        }

        function getAllSubject() {
            $scope.open = false;
            $scope.isSubject = true
            $scope.filterObj['subject'] = [];
            multipleBatchFilterCtrl.showMultiSubject = [];


            multipleBatchFilterCtrl.showThisSubject = _.find(academicDetail, (lst) => {
                return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass
            })

            let allSubject = _.flatten(_.pluck(multipleBatchFilterCtrl.showThisSubject.subject_package, 'subjects'))
            _.each(multipleBatchFilterCtrl.allSubjects, function(v) {
                _.each(allSubject, function(k) {
                    if (v._id === k) {
                        var item = {
                            _id: v._id,
                            name: v.name
                        }
                        multipleBatchFilterCtrl.showMultiSubject.push(item)
                    }
                })
            })

            if (multipleBatchFilterCtrl.showMultiSubject.length <= 0) {
                $scope.isSubject = false
            } else {
                multipleBatchFilterCtrl.checkAllSubject = false
            }
        }

        $scope.selectBatches = (opt) => {
            $scope.open = false;
            clearUsersListResults();
            clearFilterResult()
            if (opt == "all") {
                if (multipleBatchFilterCtrl.checkAll) {
                    $scope.filterObj['batch'] = _.union($scope.filterObj['batch'], _.pluck($scope.showMultiBatch, "_id"))
                    getAllSubject();
                } else {
                    $scope.filterObj['batch'] = []
                    multipleBatchFilterCtrl.showMultiSubject = []
                    $scope.isSubject = false
                }
            } else {
                if ($scope.filterObj['batch'].length == _.pluck($scope.showMultiBatch, "_id").length) {
                    multipleBatchFilterCtrl.checkAll = true
                } else {
                    multipleBatchFilterCtrl.checkAll = false
                    if ($scope.filterObj['batch'].length === 0) {
                        multipleBatchFilterCtrl.showMultiSubject = []
                        $scope.isSubject = false
                    }
                }
            }
        }

        $scope.selectClasses = (opt) => {
            $scope.open = false;
            clearFilterResult()
            if (opt == "all") {
                if (multipleBatchFilterCtrl.checkAllClass) {
                    $scope.filterObj['xclass'] = _.union($scope.filterObj['xclass'], multipleBatchFilterCtrl.classArr)
                    filterBatchBasedOnClass(multipleBatchFilterCtrl.classArr);
                    clearFields()
                } else {
                    $scope.filterObj['xclass'] = [];
                    clearFields()
                    $scope.showMultiBatch = [];
                    $scope.isBatch = false;
                    multipleBatchFilterCtrl.showBatchName = []


                }
            } else {
                if ($scope.stateId === 'userManagement') {
                    $scope.filterObj['xclass'] = [];
                    $scope.filterObj['xclass'].push($scope.filterObj['singlefieldclass'])
                }
                if ($scope.filterObj['xclass'].length == multipleBatchFilterCtrl.classArr.length) {
                    multipleBatchFilterCtrl.checkAllClass = true
                } else {
                    multipleBatchFilterCtrl.checkAllClass = false
                }
            }
        }

        $scope.selectAnnouncementReceivers = (opt) => {
            console.log(opt)
        }

        $scope.selectSubject = (opt) => {
            $scope.open = false;
            clearUsersListResults();
            clearFilterResult()
            if (opt == "all") {
                if (multipleBatchFilterCtrl.checkAllSubject) {
                    $scope.filterObj['subject'] = _.union($scope.filterObj['subject'], _.pluck(multipleBatchFilterCtrl.showMultiSubject, "_id"))
                } else {
                    $scope.filterObj['subject'] = [];
                }
            } else {
                if ($scope.filterObj['subject'].length == multipleBatchFilterCtrl.showMultiSubject.length) {
                    multipleBatchFilterCtrl.checkAllSubject = true
                } else {
                    multipleBatchFilterCtrl.checkAllSubject = false

                }
            }
        }

        function filterBatchBasedOnClass(totalClass) {
            $scope.isBatch = true
                /* multipleBatchFilterCtrl.showThisBatch = AcademicConsole.findOne({
                    session_id: $scope.selectCuriculum,
                    curriculum_id: $scope.selectClass
                }, {
                    xclass: 1
                }) */

            multipleBatchFilterCtrl.showThisBatch = _.find(academicDetail, (lst) => {
                return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass
            })


            multipleBatchFilterCtrl.showBatchName = [];
            for (var i = totalClass.length - 1; i >= 0; i--) {
                var classDet = _.find(multipleBatchFilterCtrl.showThisBatch.xclass, function(batch) {
                    return batch._id === totalClass[i]
                })

                _.each(multipleBatchFilterCtrl.allBatchess.list, function(v) {
                    _.each(classDet.batches, function(k) {
                        if (v._id === k) {
                            var item = {
                                _id: v._id,
                                name: v.name
                            }
                            multipleBatchFilterCtrl.showBatchName.push(item)
                        }
                    })
                })
            }
            $scope.showMultiBatch = _.uniq(multipleBatchFilterCtrl.showBatchName, false, function(p) {
                return p._id;
            });
            if ($scope.showMultiBatch.length <= 0) {
                $scope.isBatch = false
            }
        }

        multipleBatchFilterCtrl.searchValuesBasedOnFilterOnComponent = function() {

            $scope.open = false;
            multipleBatchFilterCtrl.userFilter = {}
            multipleBatchFilterCtrl.userFilter.roleId = $scope.filterObj.role_id
            multipleBatchFilterCtrl.userFilter.sessionId = $scope.filterObj.session
            multipleBatchFilterCtrl.userFilter.curriculumId = $scope.filterObj.curriculum
            multipleBatchFilterCtrl.userFilter.classId = $scope.filterObj.xclass
            multipleBatchFilterCtrl.userFilter.batchId = $scope.filterObj.batch
            $scope.isSearched = true;

            if ($scope.filterObj === undefined || $scope.filterObj.role_id === undefined) {
                toastr.error('Please Select the Role')
                return false;
            } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.session === undefined)) {
                toastr.error('Please Select the Session')
                return false;
            } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.curriculum === undefined)) {
                toastr.error('Please Select the Curriculum')
                return false;
            } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.xclass === undefined || $scope.filterObj.xclass.length <= 0)) {
                toastr.error('Please Select the Class')
                return false;
            } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.batch === undefined || $scope.filterObj.batch.length <= 0)) {
                toastr.error('Please Select the Batch')
                return false;
            }
            setFilterValue($scope.filterObj)
        }

        function setFilterValue(userAcademicDetails) {

            multipleBatchFilterCtrl.userMgt = {}
            multipleBatchFilterCtrl.userMgt.roleId = userAcademicDetails.role_id
            multipleBatchFilterCtrl.userMgt.sessionId = userAcademicDetails.session
            multipleBatchFilterCtrl.userMgt.curriculumId = userAcademicDetails.curriculum
            multipleBatchFilterCtrl.userMgt.classId = userAcademicDetails.xclass
            multipleBatchFilterCtrl.userMgt.batchId = userAcademicDetails.batch
                // multipleBatchFilterCtrl.getUsersLists(0, limit);
            initController();
        }

        //Added for sending announcement to all users without listing list
        multipleBatchFilterCtrl.getAllUsersForAnnouncement = () => {
            $scope.loading = true

            let req = vm.userMgt
            req["school_id"] = localStorageService.get('school_id')


            /*
             * To get all users against selected role
             * 
             * @Developer : Jeevanantham N
             */
            authService.callAPI(filterCons.API_POST_GET_ALL_USERS, "POST", req, (response) => {
                if (response.result && response.result.data && response.result.data.users) {
                    if ((response.result.data.users === undefined || response.result.data.users.length === 0))
                        toastr.error("No results found");
                    else if ((response.result.data.users && response.result.data.users.length != 0)) {
                        //console.log('**************')
                        // $scope.filteredNotEndorsedUsers = res.users
                        $scope.filteredNotEndorsedUsers.push(...response.result.data.users);
                        //console.log($scope.filteredNotEndorsedUsers)
                        //console.log('**************')
                        $scope.ProcessValue()
                    }

                    $scope.loading = false;
                    _.defer(function() {
                        $scope.$apply();
                    });
                } else {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                }
            })
        }

        multipleBatchFilterCtrl.getUsersLists = (skip, limit, page) => {
            $scope.open = false;
            multipleBatchFilterCtrl.showList = true
                // multipleBatchFilterCtrl.allItemsSelected = []
            $scope.loading = true

            let req = vm.userMgt
            req["school_id"] = localStorageService.get('school_id')
            req["skip"] = skip
            req["limit"] = limit

            /*
             * To get all users against selected role
             * 
             * @Developer : Jeevanantham N
             */
            authService.callAPI(filterCons.API_POST_GET_ALL_USERS, "POST", req, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.users) {
                    if ((response.result.data.users === undefined || response.result.data.users.length === 0)) {
                        $scope.loading = false;
                        toastr.error("No results found");
                    } else if ((response.result.data.users && response.result.data.users.length != 0)) {
                        vm.Items = response.result.data.totallength;
                        vm.pager = GetPager(vm.Items, page);
                        vm.pageIndex.push(page);
                        bindData(response.result.data, page)
                    }

                    let userList = []
                    if ($scope.isClub && $scope.userNames) {
                        let availableMembers = _.uniq(_.pluck($scope.userNames, 'user_id'));
                        _.each($scope.filteredNotEndorsedUsers, function(each, index) {
                            if (availableMembers.indexOf(each._id) != -1) {
                                each.isExists = true
                            }
                        })

                        $scope.userNamesNotEndorsed = $scope.filteredNotEndorsedUsers
                        $scope.userNamesNotEndorsed.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                    }

                    $scope.loading = false;
                    $scope.UniqueNoText = "Employee No";

                    if ($scope.userNamesNotEndorsed && $scope.userNamesNotEndorsed[0].role == "student") {
                        $scope.UniqueNoText = "Admission No";
                    }

                    _.defer(function() {
                        $scope.$apply();
                    });
                } else {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                }
            })

        }

        function bindData(res, page) {
            _.each(res.users, function(user) {
                user.page = page
            })
            $scope.userNamesNotEndorsed = res.users;
            $scope.userNamesNotEndorsed.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            $scope.filteredNotEndorsedUsers.push(...res.users);
            $scope.filteredNotEndorsedUsers.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            multipleBatchFilterCtrl.userNotEndorsedAcademic = _.uniq(_.pluck(res.users, 'academic_details'));
            multipleBatchFilterCtrl.userNotEndorsedAcademic.sort(function(a, b) {
                if (a.name && b.name) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }
            });
        }

        multipleBatchFilterCtrl.selectAllNotEndorsed = (selected, index, acade) => {
            $scope.open = false;
            if (acade != undefined) {
                let cnt = 0
                _.each($scope.filteredNotEndorsedUsers, function(user) {
                    if (user.academic_details === acade && user.page == vm.pager.currentPage) {
                        cnt = cnt + 1;
                        user.isChecked = selected
                    }
                })
                let userTo = _.filter($scope.filteredNotEndorsedUsers, function(user) {
                    return user.isChecked === true && user.academic_details === acade && user.page == vm.pager.currentPage
                })

                if (cnt === userTo.length) {
                    multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage][index] = true
                } else {
                    multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage][index] = false;
                }

            } else {
                _.each($scope.filteredNotEndorsedUsers, function(user) {
                    if (user.page == vm.pager.currentPage)
                        user.isChecked = selected
                })
            }
            $scope.filteredNotEndorsedUsers.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        }


        multipleBatchFilterCtrl.getClickedNotEndorsedUser = (person, index, acade) => {
            $scope.open = false;
            if (acade != undefined) {
                let cnt = 0
                _.each($scope.filteredNotEndorsedUsers, function(user) {
                    if (user.academic_details === acade && user.page == vm.pager.currentPage) {
                        cnt = cnt + 1;
                    }
                })

                let userTo = _.filter($scope.filteredNotEndorsedUsers, function(user) {
                    return user.isChecked === true && user.academic_details === acade && user.page == vm.pager.currentPage
                })

                if (cnt === userTo.length) {
                    multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage][index] = true
                } else {
                    multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage][index] = false
                }

            } else {
                let userTo = _.filter($scope.filteredNotEndorsedUsers, function(user) {
                    return user.isChecked === true && user.page == vm.pager.currentPage
                })
                if ($scope.filteredNotEndorsedUsers.length === userTo.length) {
                    multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage] = true
                } else {
                    multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage] = false
                }
            }
            $scope.filteredNotEndorsedUsers.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

        }


        $scope.saveSearchFilter = () => {
            $scope.open = false;

            var filterItem = {
                'school_id': localStorageService.get('school_id'),
                'title': multipleBatchFilterCtrl.saveName,
                'state': $scope.stateId,
                'role': $scope.filterObj.role_id,
                'session': $scope.filterObj.session,
                'curriculum': $scope.filterObj.curriculum,
                'class': $scope.filterObj.xclass,
                'batch': $scope.filterObj.batch,
                'subject': $scope.filterObj.subject,
                'check_all_batch': multipleBatchFilterCtrl.checkAll,
                'check_all_class': multipleBatchFilterCtrl.checkAllClass,
                'check_all_subject': multipleBatchFilterCtrl.checkAllSubject,
                'chart_type': $scope.filterObj.chart,
                'multirole': $scope.filterObj.multirole
            }

            if ($scope.filterObj.role_id === undefined && $scope.filterObj.session === undefined) {
                toastr.error("Please select atleast one field")
                return false
            }

            if (!multipleBatchFilterCtrl.saveName) {
                toastr.error("Please enter title")
                return false
            }

            /*
             * To add filter data
             * 
             * @Developer : Jeevanantham N
             */
            authService.callAPI(filterCons.API_POST_ADD_SERACH, "POST", filterItem, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.info) {
                    multipleBatchFilterCtrl.saveName = undefined;
                    getSavedSearch()
                    toastr.success("Successfully saved");
                } else {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                }
            })
        }

        $scope.openDropdown = function(data) {

            if (data) {
                $scope.open = !$scope.open;
            }
        };


        $scope.getSavedData = (savedDet) => {
            $scope.open = false;
            $scope.selectedFilterData = savedDet.title
                // $scope.openDropdown("open");
            multipleBatchFilterCtrl.selectedSavedSerach = savedDet
            clearComponentField()
            multipleBatchFilterCtrl.getCuriculum(savedDet.session)
            multipleBatchFilterCtrl.getClass(savedDet.curriculum)
            $scope.filterObj['role'] = savedDet.role;
            $scope.filterObj['session'] = savedDet.session;
            $scope.filterObj['curriculum'] = savedDet.curriculum;
            $scope.selectCuriculum = savedDet.session;

            if (savedDet.check_all_class) {
                $scope.selectClasses('all')
            }

            if (savedDet.class != undefined) {
                if ($scope.stateId === 'userManagement') {
                    multipleBatchFilterCtrl.getBatch(savedDet.class[0])
                    $scope.filterObj['xclass'] = [];
                    $scope.filterObj['xclass'].push(savedDet.class);
                    $scope.filterObj['singlefieldclass'] = savedDet.class[0];
                } else {
                    for (var i = savedDet.class.length - 1; i >= 0; i--) {
                        multipleBatchFilterCtrl.getBatch(savedDet.class[i])
                    }
                }

            }

            if (savedDet.check_all_batch) {
                multipleBatchFilterCtrl.checkAll = true
                $scope.selectBatches('all')
            }
            $scope.filterObj['xclass'] = savedDet.class
            $scope.filterObj['batch'] = savedDet.batch
            $scope.filterObj['subject'] = savedDet.subject
            $scope.filterObj['role_id'] = savedDet.role
            multipleBatchFilterCtrl.checkAllClass = savedDet.check_all_class
            multipleBatchFilterCtrl.checkAllSubject = savedDet.check_all_subject
            $scope.filterObj['chart'] = savedDet.chart_type
            $scope.filterObj['multirole'] = savedDet.multirole
            $scope.selectCuriculum = savedDet.session

            try {
                if ($scope.stateId === 'userManagement') {

                    $scope.searchValuesBasedOnFilter();
                }
            } catch (ex) {

            }
        }

        $scope.unsetValue = () => {
            $scope.saved_search = null
        }



    }
}

export default CommonFilterController;


// WEBPACK FOOTER //
// ./src/app/commonFilter/controllers/commonFilterController.js